module.exports = __webpack_public_path__ + "static/img/rrrr_12.d55dbb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/rrrr_12.png
// module id = zuvr
// module chunks = 1